
import React, { useState } from 'react';
import { Plus, X } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';

interface KeywordInputProps {
  keywords: string[];
  setKeywords: (keywords: string[]) => void;
}

export const KeywordInput: React.FC<KeywordInputProps> = ({ keywords, setKeywords }) => {
  const [newKeyword, setNewKeyword] = useState('');

  const addKeyword = () => {
    if (newKeyword.trim() && !keywords.includes(newKeyword.trim())) {
      setKeywords([...keywords, newKeyword.trim()]);
      setNewKeyword('');
    }
  };

  const removeKeyword = (keywordToRemove: string) => {
    setKeywords(keywords.filter(keyword => keyword !== keywordToRemove));
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="keywords">Keywords</Label>
      <div className="flex gap-2">
        <Input 
          id="keywords" 
          placeholder="Add keywords related to your paper"
          value={newKeyword}
          onChange={(e) => setNewKeyword(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              addKeyword();
            }
          }}
          className="h-12"
        />
        <Button 
          type="button" 
          variant="outline" 
          onClick={addKeyword}
          className="h-12 px-4"
        >
          <Plus className="h-4 w-4" />
        </Button>
      </div>
      
      {keywords.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3">
          {keywords.map((keyword, index) => (
            <div 
              key={index}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary text-sm"
            >
              <span>{keyword}</span>
              <button 
                type="button" 
                onClick={() => removeKeyword(keyword)}
                className="h-4 w-4 rounded-full flex items-center justify-center text-muted-foreground hover:text-foreground transition-colors"
              >
                <X className="h-3 w-3" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
